export const POPUP_ID = 'ai-tools-rescue-popup';

/**
 * `source` of the open payload, set by `useRescuePopupTriggers` (the paywall
 * closed), `usePopupAutoOpen` (a link) or a host call to
 * `AiTools.Popups.openPopup('RescuePopup', { source })`.
 */
export const RESCUE_POPUP_SOURCE = {
  /** Opened because the paywall closed. */
  PAYWALL_CLOSE: 'paywall_close',
  /** A `?modal=rescue` link: a fresh offer, opened after the login for a guest. */
  DEEP_LINK: 'deep_link',
} as const;

/**
 * First-month price of the rescue offer (50% off the monthly plan), in the
 * user's geo currency. The discount itself is attached on the server by
 * `applyRescueDiscount`; this figure is only what the popup shows.
 */
export const RESCUE_DISCOUNTED_PRICE = 9.99;
